var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_000000ff",
    "data-name": "#000000ff",
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.441,
    height: 102.441,
    viewBox: "0 0 102.441 102.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M6.691,0h89.03a7.974,7.974,0,0,1,4.486,2.235A8.105,8.105,0,0,1,102.441,6.7V95.319a7.792,7.792,0,0,1-7.167,7.123H7.341a7.8,7.8,0,0,1-5.9-3.225A8.193,8.193,0,0,1,0,95.393V6.717A8.012,8.012,0,0,1,2.329,2.143,8.1,8.1,0,0,1,6.691,0M5.116,4.322A4.346,4.346,0,0,0,3.431,7.791c-.012,4.232,0,8.465,0,12.7H99.014V8.005A4.572,4.572,0,0,0,98.02,4.99,4.434,4.434,0,0,0,94.45,3.427H8.007a4.572,4.572,0,0,0-2.891.894M3.419,23.9Q3.4,58.675,3.413,93.45a7.449,7.449,0,0,0,.3,2.875,4.313,4.313,0,0,0,4.088,2.7q43.518,0,87.037-.006a4.294,4.294,0,0,0,4.188-4.366q0-35.378,0-70.753Q51.224,23.9,3.419,23.9Z",
    fill: "#d9d9d9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M35.365,34.153c2.1-.166,4.22-.018,6.329-.074.718.012,1.561-.1,2.119.46a2.08,2.08,0,0,1,.556,1.717c-.022,2.137.018,4.272-.018,6.409a1.681,1.681,0,0,1-1.657,1.651c-2.265.026-4.53.012-6.795.008a1.7,1.7,0,0,1-1.767-1.641c-.028-2.277-.014-4.558-.008-6.835a1.7,1.7,0,0,1,1.241-1.695M37.534,37.5v3.413q1.708,0,3.413,0,0-1.7,0-3.413Z",
    transform: "translate(-27.29 -27.255)",
    fill: "#d9d9d9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M103.592,34.157c1.959-.192,3.944-.026,5.91-.082.812.046,1.741-.178,2.443.342a1.841,1.841,0,0,1,.692,1.625c-.012,2.207.016,4.416-.014,6.625a1.693,1.693,0,0,1-1.715,1.645c-2.065.028-4.13-.006-6.2.014a2.628,2.628,0,0,1-1.573-.306,1.752,1.752,0,0,1-.746-1.555c0-2.211-.01-4.424,0-6.633a1.7,1.7,0,0,1,1.194-1.675m2.215,3.333q0,1.708,0,3.413,1.7,0,3.411,0c0-1.138,0-2.277,0-3.413C108.084,37.489,106.945,37.491,105.807,37.491Z",
    transform: "translate(-81.903 -27.246)",
    fill: "#d9d9d9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M171.815,34.17c2.357-.218,4.75-.034,7.123-.1a1.736,1.736,0,0,1,1.941,1.561c.056,2.137,0,4.28.026,6.419a2.164,2.164,0,0,1-.568,1.819,2.444,2.444,0,0,1-1.817.452c-2.065-.024-4.13.018-6.195-.018a1.679,1.679,0,0,1-1.657-1.661c-.026-2.265-.012-4.532-.008-6.8a1.707,1.707,0,0,1,1.154-1.679m2.257,3.319q0,1.708,0,3.413,1.7,0,3.413,0V37.489Z",
    transform: "translate(-86.998 -27.245)",
    fill: "#d9d9d9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M42.638,146.611a1.665,1.665,0,0,1,1.623-1.579,24.785,24.785,0,0,1,3.011.038,1.709,1.709,0,0,1,.976,2.679c-.492.722-1.427.7-2.2.7.014.778.022,1.721-.706,2.207a1.7,1.7,0,0,1-2.675-1.03A26.066,26.066,0,0,1,42.638,146.611Z",
    transform: "translate(-34.082 -115.993)",
    fill: "#d9d9d9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M90.342,145.071c1.449-.074,2.9,0,4.354-.034a2.859,2.859,0,0,1,2,.414,1.716,1.716,0,0,1,.028,2.571,2.8,2.8,0,0,1-2.019.44c-1.407-.026-2.813.026-4.22-.022a1.694,1.694,0,0,1-.14-3.369Z",
    transform: "translate(-71.092 -116.017)",
    fill: "#d9d9d9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M148.676,145.075c1.723-.094,3.453-.02,5.178-.038a1.734,1.734,0,0,1,1.835,1.389,1.705,1.705,0,0,1-1.645,2.013c-1.667.022-3.337.016-5,0a1.7,1.7,0,0,1-.364-3.365Z",
    transform: "translate(-117.826 -116.009)",
    fill: "#d9d9d9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M207.205,145.067c1.723-.056,3.449-.018,5.174-.02a1.707,1.707,0,0,1,1.749,1.581,1.686,1.686,0,0,1-1.557,1.809c-1.667.048-3.335.012-5,.018a1.736,1.736,0,0,1-1.787-1.232A1.7,1.7,0,0,1,207.205,145.067Z",
    transform: "translate(-164.552 -116.017)",
    fill: "#d9d9d9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    d: "M265.594,145.073c1.443-.088,2.891,0,4.336-.04.724.01,1.579-.094,2.133.48a1.715,1.715,0,0,1-.1,2.549,3.048,3.048,0,0,1-2.041.4c-1.395-.028-2.789.032-4.182-.026a1.693,1.693,0,0,1-.15-3.359Z",
    transform: "translate(-211.316 -116.013)",
    fill: "#d9d9d9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M323.751,145.1a36.432,36.432,0,0,1,4.132-.1c.852.046,1.859-.2,2.559.432a1.716,1.716,0,0,1,.026,2.529,2.685,2.685,0,0,1-2,.46c-1.4-.024-2.793.02-4.188-.016a1.7,1.7,0,0,1-.528-3.309Z",
    transform: "translate(-258.051 -115.982)",
    fill: "#d9d9d9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M382.459,145.07c1.447-.084,2.9,0,4.346-.038a2.986,2.986,0,0,1,2.019.4,1.718,1.718,0,0,1,.018,2.609c-.608.542-1.479.39-2.225.414-1.341-.026-2.681.034-4.02-.024a1.7,1.7,0,0,1-1.453-2.325A1.672,1.672,0,0,1,382.459,145.07Z",
    transform: "translate(-304.782 -116.012)",
    fill: "#d9d9d9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M440.062,145.476c.628-.6,1.559-.412,2.347-.448.838.048,1.843-.184,2.513.462.726.632.522,1.677.556,2.529-.04.81.16,1.769-.446,2.421a1.716,1.716,0,0,1-2.593-.07,2.891,2.891,0,0,1-.392-1.909,2.755,2.755,0,0,1-1.995-.466A1.712,1.712,0,0,1,440.062,145.476Z",
    transform: "translate(-351.568 -116.008)",
    fill: "#d9d9d9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M227.009,189.393a1.7,1.7,0,0,1,3.391-.006c.04,1.158,0,2.319.014,3.479,1.166.016,2.335-.03,3.5.016a1.694,1.694,0,0,1-.024,3.385c-1.16.044-2.321,0-3.481.016-.014,1.168.03,2.337-.014,3.5a1.7,1.7,0,0,1-3.387,0c-.04-1.166,0-2.333-.012-3.5-1.164-.02-2.331.028-3.5-.016a1.7,1.7,0,0,1,0-3.387c1.164-.042,2.331,0,3.5-.014C227.013,191.708,226.973,190.549,227.009,189.393Z",
    transform: "translate(-177.485 -150.183)",
    fill: "#d9d9d9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M43.786,198.284a1.7,1.7,0,0,1,2.263,1.469c.038,2.067.02,4.136.01,6.2a1.7,1.7,0,0,1-3.4,0c-.022-2-.014-4.006,0-6.008A1.707,1.707,0,0,1,43.786,198.284Z",
    transform: "translate(-34.116 -158.526)",
    fill: "#d9d9d9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M453.472,198.263a1.7,1.7,0,0,1,2.163,1.483c.06,1.8,0,3.605.028,5.406a2.781,2.781,0,0,1-.39,1.875,1.71,1.71,0,0,1-2.509.146,2,2,0,0,1-.524-1.625c.014-1.873-.012-3.744.01-5.616A1.7,1.7,0,0,1,453.472,198.263Z",
    transform: "translate(-361.753 -158.535)",
    fill: "#d9d9d9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M43.057,269.43a1.716,1.716,0,0,1,2.617.058,2.924,2.924,0,0,1,.386,1.9,2.685,2.685,0,0,1,2.025.494,1.711,1.711,0,0,1-.06,2.505c-.632.58-1.547.4-2.327.432-.876-.04-1.943.192-2.6-.55-.62-.632-.436-1.583-.468-2.383C42.677,271.069,42.453,270.1,43.057,269.43Z",
    transform: "translate(-34.098 -215.06)",
    fill: "#d9d9d9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M442.712,269.179a1.705,1.705,0,0,1,2.723,1.078,27.758,27.758,0,0,1,.01,3,1.708,1.708,0,0,1-1.833,1.531,15.514,15.514,0,0,1-3.005-.11,1.712,1.712,0,0,1-.682-2.723c.51-.634,1.383-.586,2.117-.59C442.03,270.6,442.012,269.675,442.712,269.179Z",
    transform: "translate(-351.565 -215.033)",
    fill: "#d9d9d9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M89.934,281.7a6.857,6.857,0,0,1,1.953-.13c1.267.022,2.535-.032,3.8.02a1.7,1.7,0,0,1,1.567,2.017,1.717,1.717,0,0,1-1.751,1.375c-1.671,0-3.345.024-5.018-.01a1.7,1.7,0,0,1-.552-3.271Z",
    transform: "translate(-71.086 -225.227)",
    fill: "#d9d9d9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M148.294,281.73a4.175,4.175,0,0,1,1.535-.16c1.4.024,2.8-.02,4.2.016a1.7,1.7,0,0,1,.018,3.393c-1.675.024-3.349.016-5.022,0a1.7,1.7,0,0,1-.732-3.253Z",
    transform: "translate(-117.82 -225.233)",
    fill: "#d9d9d9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M206.813,281.645a46.982,46.982,0,0,1,5.178-.122,1.892,1.892,0,0,1,2.021,1.046,1.7,1.7,0,0,1-1.413,2.351c-1.675.05-3.351.012-5.028.02a1.738,1.738,0,0,1-1.751-1.156A1.711,1.711,0,0,1,206.813,281.645Z",
    transform: "translate(-164.563 -225.184)",
    fill: "#d9d9d9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M265.185,281.726a4.342,4.342,0,0,1,1.559-.156c1.4.024,2.8-.022,4.194.018a1.7,1.7,0,0,1,.018,3.389c-1.607.034-3.215,0-4.824.014a1.816,1.816,0,0,1-1.711-.822A1.714,1.714,0,0,1,265.185,281.726Z",
    transform: "translate(-211.317 -225.233)",
    fill: "#d9d9d9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M323.574,281.749a4.4,4.4,0,0,1,1.727-.178c1.4.028,2.8-.036,4.2.026a1.693,1.693,0,0,1-.022,3.373c-1.595.05-3.191,0-4.786.022a1.906,1.906,0,0,1-1.763-.732A1.717,1.717,0,0,1,323.574,281.749Z",
    transform: "translate(-258.07 -225.233)",
    fill: "#d9d9d9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M382.086,281.706a6.566,6.566,0,0,1,1.961-.138c1.327.032,2.655-.052,3.978.036a1.7,1.7,0,0,1,1.172,2.583,1.853,1.853,0,0,1-1.753.8c-1.6-.016-3.211.024-4.814-.02a1.7,1.7,0,0,1-.544-3.261Z",
    transform: "translate(-304.803 -225.227)",
    fill: "#d9d9d9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M44,324.281a14.963,14.963,0,0,1,1.919-.048q40.117.006,80.236,0A1.723,1.723,0,0,1,128,325.988c.02,8.331-.006,16.665.012,25a2.539,2.539,0,0,1-.316,1.539,1.767,1.767,0,0,1-1.557.732q-40.315.012-80.631.006c-.756-.028-1.639.136-2.257-.406a1.945,1.945,0,0,1-.616-1.675c.014-8.4-.008-16.8.01-25.2a1.69,1.69,0,0,1,1.347-1.7m2.061,3.371q0,11.1,0,22.191,39.268,0,78.536,0,0-11.1,0-22.195Q85.324,327.654,46.056,327.652Z",
    transform: "translate(-34.106 -259.355)",
    fill: "#d9d9d9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignDefault);
export default __webpack_public_path__ + "static/media/DesignDefault.7f4afbf24c128726b2e9cb68b77c6717.svg";
export { ForwardRef as ReactComponent };